import type { TargetKind, Vec3 } from '@shooting-range/shared';

export function sourceBearing(source: Vec3, viewer: Vec3, yaw: number) {
  const dx = source.x - viewer.x, dy = source.y - viewer.y, dz = source.z - viewer.z;
  const right = dx * Math.cos(yaw) - dz * Math.sin(yaw);
  const forward = -dx * Math.sin(yaw) - dz * Math.cos(yaw);
  const angle = Math.atan2(right, forward);
  const directions = ['AHEAD', 'FRONT RIGHT', 'RIGHT', 'BEHIND RIGHT', 'BEHIND', 'BEHIND LEFT', 'LEFT', 'FRONT LEFT'];
  const direction = directions[(Math.round(angle / (Math.PI / 4)) + 8) % 8]!;
  return { angle: angle * 180 / Math.PI, direction, distance: Math.hypot(dx, dy, dz), above: dy > 2,
    pan: Math.sin(angle) * Math.min(1, Math.hypot(dx, dz) / 3) };
}

export function attackerKind(kind: TargetKind | undefined, source: Vec3): 'raider' | 'runner' | 'brute' | 'crawler' | 'husk' {
  if (kind === 'raider' || kind === 'runner' || kind === 'brute' || kind === 'crawler' || kind === 'husk') return kind;
  // An attack can precede the first target snapshot. Current elevated attackers are window raiders.
  return source.y > 3 ? 'raider' : 'runner';
}

export function attackerLabel(kind: 'raider' | 'runner' | 'brute' | 'crawler' | 'husk', source: Vec3): string {
  return kind === 'raider' ? source.y > 3 ? 'WINDOW RAIDER' : 'RAIDER' : kind === 'brute' ? 'BRUTE' : kind === 'crawler' ? 'CRAWLER' : kind === 'husk' ? 'HUSK' : 'STALKER';
}
